import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-label" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString($props.name) + " ", 1),
    ($props.isRequired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "  * "))
      : _createCommentVNode("", true)
  ]))
}